import type { BaseObj } from '../BaseObj';
import { FieldDef, type FieldDefinedFor } from './FieldDef';
import type { DtoClass } from '@/objects/generated';

export abstract class GuiDef<T extends BaseObj> {
    constructor(name: DtoClass) {
        this.Fields = [];
        this.Name = name;
    }

    public Name: DtoClass;

    public abstract LoadDependencies(): Promise<void>;
    public Groups(type: FieldDefinedFor = 'Both'): FieldDef<T>[][] {
        // group Fields by Group property
        return this.Fields.filter((field: FieldDef<T>) => field.IsDefinedFor(type)).reduce((arr: FieldDef<T>[][], field: FieldDef<T>) => {
            const grouped = arr.find((group) => field.Group != null && group[0].Group?.Group === field.Group?.Group);
            if (grouped) {
                grouped.push(field);
            } else {
                arr.push([field]);
            }

            return arr;
        }, []);
    }

    public Fields: FieldDef<T>[];
}
